module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "bg-bordered",
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 24
    }
  }, [(_vm.rtxActive && _vm.rtxActive > 0) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Active",
      "value": _vm.rtxActive,
      "icon": "fa fa-tasks",
      "align": "center",
      "color": "#0EABDD",
      "caption-color": "slategrey",
      "no-plural": "",
      "on-click": _vm.showActive
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rtxRejected && _vm.rtxRejected > 0) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Rejected",
      "value": _vm.rtxRejected,
      "icon": "fa fa-exclamation-triangle",
      "align": "center",
      "color": "#F8D83A",
      "caption-color": "slategrey",
      "no-plural": "",
      "on-click": _vm.showRejected
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rtxClosed && _vm.rtxClosed > 0) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1,
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Closed",
      "value": _vm.rtxClosed,
      "icon": "fa fa-flag",
      "align": "center",
      "color": "#64CD75",
      "caption-color": "slategrey",
      "no-plural": "",
      "on-click": _vm.showClosed
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09388cfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RequestStats.vue
// module id = 1408
// module chunks = 0